module.exports = __webpack_public_path__ + "static/img/nblock.bb75f4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nblock.jpg
// module id = E4+7
// module chunks = 1